import { render, staticRenderFns } from "./HeaderBackground.vue?vue&type=template&id=6add8926"
import script from "./HeaderBackground.vue?vue&type=script&lang=ts"
export * from "./HeaderBackground.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports